import useCrud from "../../../../hooks/useCrud";
import { ACTIONS, COLUMN_TYPE, FORNECEDOR_VALUES_DEFAULT } from "../../../../utils/financialHelper";
import FormFornecedores from "./FormFornecedores";
import CrudTablePage from "../../../../components/Financial/CrudTablePage";

const Fornecedores = () => {
  const headCells = [
    { key: 'tradeName', field: 'tradeName', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Nome Fantasia' },
    { key: 'cpfCnpj', field: 'cpfCnpj', type: COLUMN_TYPE.STRING, alignRight: false, label: 'CPF/CNPJ' },
    { key: 'email', field: 'email', type: COLUMN_TYPE.STRING, alignRight: false, label: 'E-mail' },
    { key: 'phone', field: 'phone', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Telefone' },
    { key: 'contactPerson', field: 'contactPerson', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Contato' },
    { key: 'actions', field: 'actions', type: COLUMN_TYPE.BUTTONS, alignRight: true, label: 'Ações' },
  ];

  const funcionalidade = 'Fornecedores'

  const {
    action,
    buttonLabel,
    dadoFoiModificado,
    filterValue,
    isLoading,
    isLoadingSubmit,
    items: fornecedores,
    open,
    title,
    values,
    setAction,
    setButtonLabel,
    setDadoFoiModificado,
    setFilterValue,
    setItems: setFornecedores,
    setValues,
    handleClose,
    handleDelete,
    handleEdit,
    handleOpen,
    handleSubmit,
    handleView,
  } = useCrud('/suppliers', FORNECEDOR_VALUES_DEFAULT, funcionalidade);

  return (
    <CrudTablePage
      isLoading={isLoading}
      funcionalidade={funcionalidade}
      rows={fornecedores}
      setRows={setFornecedores}
      headCells={headCells}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      filterValue={filterValue}
      setFilterValue={setFilterValue}
      dadoFoiModificado={dadoFoiModificado}
      setDadoFoiModificado={setDadoFoiModificado}
      open={open}
      title={title}
      buttonLabel={buttonLabel}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      action={action}
      handleOpen={handleOpen}
    >
      <FormFornecedores
        values={values}
        setValues={setValues}
        isDelete={action === ACTIONS.DELETE}
        isLoadingSubmit={isLoadingSubmit}
      />
    </CrudTablePage>
  )
}

export default Fornecedores